import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const FilterBar = ({ filterComponents, withBottomMargin }) => {
  const [showAll, setShowAll] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10); // default for desktop

  useEffect(() => {
    const updateVisibleCount = () => {
      const width = window.innerWidth;
      if (width < 768) {
        // Small tablets and mobile devices
        setVisibleCount(2);
      } else if (width < 900) {
        // Medium tablets / small laptops
        setVisibleCount(3);
      } else if (width < 1080) {
        // Just below desktop
        setVisibleCount(5);
      } else {
        // Full desktop and up
        setVisibleCount(10);
      }
    };

    updateVisibleCount(); // on mount
    window.addEventListener('resize', updateVisibleCount);

    return () => window.removeEventListener('resize', updateVisibleCount);
  }, []);

  const visibleFilters = showAll
    ? filterComponents
    : filterComponents.slice(0, visibleCount);

  const shouldShowToggle = filterComponents.length > visibleCount;

  return (
    <div className="w-full">
      <div className={clsx('flex flex-wrap gap-1', { 'pb-5': withBottomMargin })}>
        {visibleFilters.map((filter) => (
          <div key={filter.key} className="inline-block whitespace-nowrap">
            {filter.element}
          </div>
        ))}

        {shouldShowToggle && (
          <button
            className="px-3 py-2 border rounded-2xl bg-white text-sm flex-shrink-0"
            onClick={() => setShowAll((prev) => !prev)}
            type="button"
          >
            {showAll ? 'Show Less' : 'More Filters'}
          </button>
        )}
      </div>
    </div>
  );
};

FilterBar.propTypes = {
  filterComponents: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      element: PropTypes.node,
    }),
  ).isRequired,
  withBottomMargin: PropTypes.bool.isRequired,
};

export default FilterBar;
